import { render, staticRenderFns } from "./DialogRequestResetPassword.vue?vue&type=template&id=0473a216&scoped=true&"
import script from "./DialogRequestResetPassword.vue?vue&type=script&lang=ts&"
export * from "./DialogRequestResetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./DialogRequestResetPassword.vue?vue&type=style&index=0&id=0473a216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0473a216",
  null
  
)

export default component.exports